import { ButtonModule } from 'primeng/button';
import { AfterViewInit, Component } from '@angular/core';
import { LoaderComponent } from "../../utils/loader/loader.component";
import { DatepickerComponent } from "../../utils/datepicker/datepicker.component";
import { PaymentService } from '../../services/payment.service';
import { jwtDecode } from 'jwt-decode';
import { CustomTableComponent } from "../../utils/custom-table/custom-table.component";
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { FormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../theme.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-payments',
    imports: [ButtonModule, LoaderComponent, CustomTableComponent, FormsModule, DatepickerComponent],
    templateUrl: './payments.component.html',
    styleUrl: './payments.component.scss',
    providers: [provideNgxMask()]
})
export class PaymentsComponent implements AfterViewInit {
  loading = false;
  movements: any[] = [];
  reporterURL = environment.wrUrl;
  allCards: any = [];
  totalAmountForm = 0;
  paymentService = 2;
  downloadOptions = [{
    value: 1,
    text: 'XLSX'
  }, {
    value: 2,
    text: 'PDF'
  }];

  headers: any[] = [
    { key: "date", textHeader: "Fecha", visible: true, type: "date" },
    { key: "reference", textHeader: "Referencia", visible: true, type: "string" },
    { key: "invoice", textHeader: "Factura", visible: true, type: "string" },
    { key: "cargo", textHeader: "Cargo", visible: true, type: "currency" },
    { key: "abono", textHeader: "Abono", visible: true, type: "currency" }


  ];

  tableButtons: any[] = [];



  fromDate!: Date;
  toDate!: Date;
  fromDateRequest!: Date;
  toDateRequest!: Date;
  selectedCard = -1;
  data: any;
  tokenAuth: any;
  amount = '';

  ngOnInit() {
    let today = new Date();
    this.fromDate = new Date(today.getFullYear(), today.getMonth() - 6, today.getDate());
    this.toDate = today;

  }
  constructor(private service: PaymentService, private titleService: Title, private themeService: ThemeService

  ) {
    this.titleService.setTitle("Pagos");
    this.themeService.setTitle("Mis Pagos");

    this.data = JSON.parse(localStorage.getItem('data')!);
  }
  ngAfterViewInit(): void {
    this.tableButtons = this.data.PurchaseType != 'Credit' ? [
      {
        text: 'Remisión',
        action: (event: any) => this.downloadRemission(event),
        icon: File,
        hasIcon: false,
        color: "",
        showText: true,
      }

    ] : [];
    this.getPayments();
  }

  setDatesOnFilter(event: any) {
    this.fromDate = event.from;
    this.toDate = event.to;
  }

  changeDeviceFilter(event: any, isFromCard: boolean) {
    this.selectedCard = event.value;
  }





  getPayments() {
    this.loading = true;
    this.fromDateRequest = new Date(this.fromDate);
    this.toDateRequest = new Date(this.toDate);

    this.service.getClientMovements(this.data.Client_number, this.fromDateRequest, this.toDateRequest, '').subscribe({
      next: (resp: any) => {

        resp.map((mov: any) => {
          if (mov.reference.includes("FACTURA")||mov.remission_id===0) {
            mov.disableButton = true;
          } else {
            mov.disableButton = false;
          }
        });


        this.movements = resp;


        this.loading = false;
      },
      error: (err: any) => {
        this.movements = [];
        this.loading = false;
      }
    });
  }



  downloadRemission(data: any) {
    
    let url = this.reporterURL + 'pdf/MonederoXiga.aspx?rptId=data&rptName=rpt_Remission&remission=' + data.remission_id + '&langId=2';
    window.open(url, "_blank");
  }

  download(id: string) {
    let url = '';
    let fromDateString = (this.fromDateRequest.getMonth() + 1).toString().padStart(2, "0").substring(0, 2) + '/' + (this.fromDateRequest.getDate().toString().padStart(2, "0")).substring(0, 2) + '/' + this.fromDateRequest.getFullYear()
    let toDateString = (this.toDateRequest.getMonth() + 1).toString().padStart(2, "0").substring(0, 2) + '/' + (this.toDateRequest.getDate().toString().padStart(2, "0")).substring(0, 2) + '/' + this.toDateRequest.getFullYear()
    if (id == "1") {


      url = this.reporterURL + 'Excel/MonederoXiga.aspx?rptName=payments&clientStart=' + this.data.Client_number + '&clientEnd=' + this.data.Client_number + '&contableDate=' + fromDateString + '&toContableDate=' + toDateString + '&prefix=0&isReport=1';
    } else if (id == "2") {

      url = this.reporterURL + 'pdf/MonederoXiga.aspx?rptId=data&rptName=rpt_Payments&FromDate=' + fromDateString + '&ToDate=' + toDateString + '&clientStart=' + this.data.Client_number;
    }
    window.open(url, "_blank");
  }
}
